export default {
      tableRowPerPage: [5,10,25,50,{"text":"Všetky","value":99999999}]  
}





// WEBPACK FOOTER //
// ./src/public_app/api/defaults.js